// src/Contact.js
import { Link } from 'react-router-dom';
import logo from './logo.jpg';

export default function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl space-y-4">
        {/* Back Link */}
        <Link to="/" className="text-blue-600 hover:underline font-medium">
          ← Back to Login
        </Link>

        {/* Card Container */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-indigo-600 to-blue-600 p-8 text-center">
            <img
              src={logo}
              alt="Miles2Go Logo"
              className="w-20 h-20 rounded-full mx-auto mb-4 shadow-md border-4 border-white"
            />
            <h1 className="text-3xl font-bold text-white mb-2">Contact Us</h1>
            <p className="text-blue-100 font-medium">✉️ Get in touch with us</p>
          </div>
          {/* Body */}
          <div className="p-6 space-y-6 text-gray-700">
            <p className="text-sm text-gray-500 text-center">
              Last updated on 09-04-2025 23:01:34
            </p>
            <div>
              <h2 className="font-semibold text-lg">Merchant Legal Entity</h2>
              <p>SANYAM KAPOOR</p>
            </div>
            <div>
              <h2 className="font-semibold text-lg">Registered Address</h2>
              <p>
                2899/4, TOBHA CHET SINGH,<br />
                Patiala, Punjab<br />
                PIN: 147001
              </p>
            </div>
            <div>
              <h2 className="font-semibold text-lg">Operational Address</h2>
              <p>
                2899/4, TOBHA CHET SINGH,<br />
                Patiala, Punjab<br />
                PIN: 147001
              </p>
            </div>
            <div>
              <h2 className="font-semibold text-lg">Contact Details</h2>
              <p>
                Telephone:{' '}
                <a href="tel:+919780728233" className="text-blue-600 hover:underline">
                  +91 9780728233
                </a>
              </p>
              <p>
                Email:{' '}
                <a
                  href="mailto:sanyam.kapoor@miles2go.in"
                  className="text-blue-600 hover:underline"
                >
                  sanyam.kapoor@miles2go.in
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
